












































import NuxtSsrInstantsearch from 'library/components/globals/filterable-list/nuxt-ssr-instantsearch'
import {
	AisInfiniteHits
	AisStateResults

} from 'vue-instantsearch'

export default
	name: 'ArticleListing'

	props:
		block: Object
		isRecipeBlock: Boolean

	# Register instantsearch components
	components: {
		AisInfiniteHits
		AisStateResults
		NuxtSsrInstantsearch
	}

	# Get the list of categories
	fetch: ->
		{ categories } = await @$craft.execute query: """
			query {
				categories(group: "#{@categoryGroupHandle}", level: 1) {
					id, title, slug
				}
			}
			"""
		@categories = categories

	data: ->
		categories: []
		hitsPerPage: 6

	computed:

		# Form the Algolia index name
		indexName: ->
			if @isRecipeBlock then "#{process.env.APP_ENV}_recipes"
			else "#{process.env.APP_ENV}_articles"

		# Determine the categories handle for the listing type
		categoryGroupHandle: ->
			if @isRecipeBlock
			then "recipeCategories"
			else "articleCategories"

		# Used to generate the buttons list
		categoryOptions: -> [
			{
				to: @listingBasePath
				fill: if @isActivePath @listingBasePath then 'solid' else 'inverted'
				label: "All"
			}
			...@categories.map (category) =>
				to: (path = @listingBasePath + '/' + category.slug)
				fill: if @isActivePath path then 'solid' else 'inverted'
				label: category.title
		]

		# The expected route to the base tower
		listingBasePath: -> if @isRecipeBlock then "/recipes" else "/articles"

		# Get the current category slug
		activeCategorySlug: -> @$route.path.substr @listingBasePath.length + 1

		# Builds the filter for Algolia
		categoryFilter: ->
			@block.categories.map ({ slug }) -> "category.slug:#{slug}"
			.join ' OR '

	methods:

		# Is this path the current route path
		isActivePath: (path) -> path == @$route.path

